export default __webpack_public_path__ + "static/media/mobile-bg.5ad108c5.png";